import CardBadge, { CardBadgeProps } from '@/atoms/CardBadge';
import Link from 'next/link';
import { ReactNode } from 'react';

type Props = {
  cardBadgeProps: CardBadgeProps;
  children: ReactNode;
  title: string;
  href?: string;
};

const CardNews = ({ title, cardBadgeProps, children, href }: Props) => (
  <div className="p-4 border-4 border-sand-200 rounded-lg text-neutral-700">
    <div className="flex gap-2 items-center">
      <CardBadge {...cardBadgeProps} />
      {href ? (
        <Link className="underline" href={href}>
          {title}
        </Link>
      ) : (
        title
      )}
    </div>
    <div>{children}</div>
  </div>
);

export default CardNews;
